import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { searchListings, searchListingsRequest } from '../SearchPage/SearchPage.duck';
export const ASSET_NAME = 'landing-page';

export const loadData = (params, search, config) => async (dispatch, getState) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  // Set searchInProgress immediately so the spotlight shows a skeleton
  // instead of stale listings while we resolve the current user type.
  dispatch(searchListingsRequest({}));

    let { currentUser } = getState().user;
    if (!currentUser || (currentUser && !currentUser.id)) {
        currentUser = await dispatch(fetchCurrentUser());
    }
    const { accountType='company' } = (currentUser && currentUser.id && currentUser.attributes.profile.publicData) || {};
    const isCompany = (accountType && accountType == 'company')  ? false : true;

  return dispatch(searchListings(
    {
      pub_listingType: isCompany ? 'company' : 'fractionalPro',
      include: ['author', 'images'],
      'fields.image': [
        'varinats.default',
        'variants.scaled-small',
        'variants.scaled-medium',
      ],
      'limit.images': 1,
    },
    config
  )).then(() => {
  
    return dispatch(fetchPageAssets(pageAsset, true));
  });
};
